import { baseApi } from './base'
import { CreateActDto, UpdateActDto, Act } from '../models/acts.model'
import { SearchRequest } from '../types/request'
import { Tag } from './base'

export const actsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        createAct: builder.mutation<Act, CreateActDto>({
            query: (body) => ({ url: `/acts`, method: 'POST', body }),
            invalidatesTags: [Tag.ACTS]
        }),
        getActs: builder.query<Act[], SearchRequest>({
            query: (params) => ({ url: '/acts', method: 'GET', params }),
            providesTags: [Tag.ACTS]
        }),
        updateAct: builder.mutation<Act, { id: string; changes: UpdateActDto }>({
            query: ({ id, changes }) => ({ url: `/acts/${id}`, method: 'PATCH', body: changes }),
            invalidatesTags: [Tag.ACTS]
        }),
        deleteAct: builder.mutation<Act, string>({
            query: (id) => ({ url: `/acts/${id}`, method: 'DELETE' }),
            invalidatesTags: [Tag.ACTS]
        }),
    }),
    overrideExisting: false,
})

export const {
    useCreateActMutation,
    useGetActsQuery,
    useLazyGetActsQuery,
    useUpdateActMutation,
    useDeleteActMutation,
} = actsApi
